import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IApplication } from "../interfaces/IApplication";



const initialState: IApplication = {
    loggedInUser: null,
    pageTitle: "",
    backgroundPath: ""
}

export const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        setApplicationValues: (state, action: PayloadAction<IApplication>) => {
            console.log("SET APPLICATION VALUES", action.payload)
            state.loggedInUser = action.payload.loggedInUser;
        },
        setPageTitle: (state, action: PayloadAction<IApplication>) => {
            state.pageTitle = action.payload.pageTitle;
            state.backgroundPath = action.payload.backgroundPath
        },
        setBackgroundPath: (state, action: PayloadAction<IApplication>) => {
            state.backgroundPath = action.payload.backgroundPath;
        }
    }
})

export const {setApplicationValues, setPageTitle, setBackgroundPath} = applicationSlice.actions;

export const selectedLoggedInUser = (state: RootState) => state.application.loggedInUser;
export const selectedPageTitle = (state: RootState) => state.application.pageTitle;

export default applicationSlice.reducer;